import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { UpdateStatusAssociatePersonProfileInterface } from 'domain/usecases';

export class RemoteUpdateStatusAssociatePersonProfile
  implements UpdateStatusAssociatePersonProfileInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<UpdateStatusAssociatePersonProfileInterface.Result>,
  ) {}

  async execute(
    params?: UpdateStatusAssociatePersonProfileInterface.Params,
  ): Promise<UpdateStatusAssociatePersonProfileInterface.Result> {
    const httpResponse = await this.httpClient.request({
      method: 'patch',
      url: generateUrl(
        this.url + '/profiles/change-profile-status/' + params?.id,
        {
          profileId: params?.profileId,
        },
      ),
      body: {
        status: params?.status,
      },
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
